/** @format */

import { Pipe, PipeTransform } from '@angular/core';

import { PlpPromoMessages, ProductVO, PromoDetailsMap } from '@shared/data-access/interfaces';

@Pipe({
  name: 'resolvePromo',
})
export class ResolvePromoPipe implements PipeTransform {
  transform(
    product: ProductVO,
    promoList: PlpPromoMessages | PromoDetailsMap | null | undefined,
  ): string | null {
    if (!promoList) {
      return null;
    }

    const byPartNumber = promoList[product.parentPartnumber];
    const catentryKey = product.parentCatentryId || product.catentryId;
    const byCatentry = catentryKey ? promoList[catentryKey] : undefined;

    if (byPartNumber && 'plpMessage' in byPartNumber) {
      return byPartNumber.plpMessage;
    } else if (byCatentry && 'promoDesc' in byCatentry) {
      return byCatentry.promoDesc;
    }

    return null;
  }
}
